export default "__VITE_ASSET__Duj1bXZ4__"